var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummaryReportIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8392",
    "data-name": "Rectangle 8392",
    width: 27.498,
    height: 27.498,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16127",
    "data-name": "Group 16127",
    transform: "translate(-1185 -1810)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_268",
    "data-name": "Ellipse 268",
    transform: "translate(1185 1810)",
    fill: "#0082ca",
    stroke: "#0082ca",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16038",
    "data-name": "Group 16038",
    transform: "translate(1193.25 1817.236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16034",
    "data-name": "Group 16034",
    transform: "translate(0 -1)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5835",
    "data-name": "Path 5835",
    d: "M15.2,0a.724.724,0,0,0-.724.724V12.3a.724.724,0,0,0,.724.724H26.775A.723.723,0,0,0,27.5,12.3,12.315,12.315,0,0,0,15.2,0M12.3,2.895A12.3,12.3,0,1,0,24.6,15.2a.723.723,0,0,0-.724-.724H13.026V3.618a.723.723,0,0,0-.724-.724m-.724,1.471V15.2a.724.724,0,0,0,.724.724h10.83A10.856,10.856,0,1,1,11.578,4.366",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryReportIcon);
export default __webpack_public_path__ + "static/media/summary-report-icon.a45ef9c873f923c5d6cddac5f48dc59a.svg";
export { ForwardRef as ReactComponent };